import { Moment } from 'moment';

import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSelectModule } from '@angular/material/select';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { EditionsService } from './../../services/editions.service';

@Component({
  selector: 'app-admin-new-edition',
  templateUrl: './admin-new-edition.component.html',
  styleUrls: ['./admin-new-edition.component.scss']
})
export class AdminNewEditionComponent implements OnInit {
  minutes: number[];
  hours: number[];
  startDate: Moment;
  endDate: Moment;
  closeDate: Moment;
  completeCloseDate: Moment;
  selectedHour: number;
  selectedMinute: number;
  constructor(
    public dialogRef: MatDialogRef<AdminNewEditionComponent>,
    private editionsService: EditionsService,
    public snackBar: MatSnackBar
  ) {}

  ngOnInit() {
    this.minutes = [];
    this.hours = [];
    for (let i = 0; i < 4; i++) {
      this.minutes.push(i * 15);
    }
    for (let i = 0; i < 24; i++) {
      this.hours.push(i);
    }
  }

  onStartDateChange($event: MatDatepickerInputEvent<Moment>) {
    this.startDate = $event.value;
  }

  onEndDateChange($event: MatDatepickerInputEvent<Moment>) {
    this.endDate = $event.value;
  }

  onCloseDateChange($event: MatDatepickerInputEvent<Moment>) {
    this.closeDate = $event.value;
  }

  validateDates() {
    if (this.closeDate > this.startDate) {
      this.snackBar.open(
        'La fecha de cierre debe ser menor a la fecha de inicio',
        'cerrar'
      );
      return false;
    } else {
      if (this.endDate < this.startDate) {
        this.snackBar.open(
          'La fecha final debe ser menor a la fecha de inicio',
          'cerrar'
        );
        return false;
      } else {
        return true;
      }
    }
  }

  cancel() {
    this.dialogRef.close();
  }

  saveEdition() {
    if (this.validateDates()) {
      this.closeDate.hour(this.selectedHour);
      this.closeDate.minute(this.selectedMinute);
      this.editionsService
        .createEdition(this.startDate, this.endDate, this.closeDate)
        .subscribe(data => {
          if (data.success) {
            this.cancel();
          } else {
            this.snackBar.open(
              'Ya existe una edicion con esta fecha de inicio',
              'cerrar'
            );
          }
        });
    }
  }

  saveDisabled() {
    if (this.startDate && this.endDate && this.closeDate) {
      return false;
    } else {
      return true;
    }
  }
}
